// @flow

import React, { Fragment } from 'react';
import type { Node } from 'react';
import { useIntl } from 'react-intl';
import { Heading, Button } from '@riseart/common';
import { UrlAssembler } from 'shared_services/riseart/utils/UrlAssembler';
import { ContentAttribute } from 'shared_components/cms/attributes/Content';

import { cmsModuleArtistArtGridTextCls } from 'shared_components/cms/modules/artist/ArtGrid.less';

type ContentArtistProps = {
  id: number,
  alias: string,
  name: string,
  text?: Object,
  disableHeadingTags?: boolean,
};

/**
 * ArtistArtGridArtist
 *
 * @param {Object} props
 * @returns {Node}
 */
export function ArtistArtGridArtist({
  id,
  alias,
  name,
  text,
  disableHeadingTags,
}: ContentArtistProps): Node {
  const { formatMessage } = useIntl();
  const buttonLabel = formatMessage({ id: 'components.art.viewAllWorks' });

  return (
    <Fragment>
      {name ? (
        <Heading level="3" tag={disableHeadingTags ? 'span' : 'h2'}>
          {name}
        </Heading>
      ) : null}
      {text ? (
        <div className={cmsModuleArtistArtGridTextCls}>
          <ContentAttribute plainTextWrapper="p" {...text} />
        </div>
      ) : null}
      {id && alias ? (
        <Button
          isAnchor
          type="secondary"
          size="medium"
          to={UrlAssembler.artistProfile(id, alias)}
          title={buttonLabel}
        >
          {buttonLabel}
        </Button>
      ) : null}
    </Fragment>
  );
}
